module.exports = __webpack_public_path__ + "static/media/Discount.af056968.png";